import { resolveActiveTenantId } from '@/config/tenants/tenantRewrites'

export const TENANT_HEADER_NAME = 'X-GM-Tenant'

/** Nile-Core tenant slug for legacy General Medicine deploys with no `NEXT_PUBLIC_GM_TENANT_ID`. */
// TODO(GM-6520): remove once every deploy sets NEXT_PUBLIC_GM_TENANT_ID explicitly.
export const LEGACY_GENERAL_MEDICINE_TENANT_ID = 'general-medicine'

/**
 * Tenant slug sent as `X-GM-Tenant` on Nile-Core egress. Unset deploy env falls back to
 * `general-medicine` without enabling tenant rewrites or the tenant config registry.
 */
export function resolveTenantHeaderId(): string {
    const tenantId = resolveActiveTenantId()
    return tenantId ? tenantId : LEGACY_GENERAL_MEDICINE_TENANT_ID
}

/**
 * Deploy-tenant header for direct server-side Nile-Core egress and for browser
 * requests that bypass the `/api/*` middleware proxy (for example large uploads).
 * Middleware also sets this header on every proxied Nile-Core request.
 */
export function tenantHeaderRecord(): Record<string, string> {
    return { [TENANT_HEADER_NAME]: resolveTenantHeaderId() }
}
